import {observer} from 'mobx-react';
import {Avatar} from 'shared/components';
import {FormattedMessage} from 'react-intl';

const Assignee = observer(({model}) => {
  if (!model.isSpecificPerson) {
    return <FormattedMessage id={model.assigneeType}/>;
  }

  return (
    <div className='flex align-items-middle'>
      <Avatar employee={model.assignee} size='sm'/>
      <div className='pl2'>{model.assigneeName}</div>
    </div>
  );
});

export default Assignee;
